// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Header-module__headerBox--QCJXU {
    display: flex;
    padding: 10px 10px 30px 10px;
}

.Header-module__border--HVypQ {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #C7BFFF;
    padding-bottom: 20px;
    width: 100%;
}
.Header-module__logoutIcon--L6Ihb {
    color: #0054E6;
    display: flex;
    align-items: center;
    gap: 10px;
}`, "",{"version":3,"sources":["webpack://./src/shared/app-drawer/Header.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;IAChC,oBAAoB;IACpB,WAAW;AACf;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb","sourcesContent":[".headerBox {\r\n    display: flex;\r\n    padding: 10px 10px 30px 10px;\r\n}\r\n\r\n.border {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    border-bottom: 1px solid #C7BFFF;\r\n    padding-bottom: 20px;\r\n    width: 100%;\r\n}\r\n.logoutIcon {\r\n    color: #0054E6;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 10px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerBox": `Header-module__headerBox--QCJXU`,
	"border": `Header-module__border--HVypQ`,
	"logoutIcon": `Header-module__logoutIcon--L6Ihb`
};
export default ___CSS_LOADER_EXPORT___;
